import { useState, useEffect } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { LocalStorageKeys } from "../constants/localStorageKeys";

const FULL_DRAWER_WIDTH = 260;
const COLLAPSED_DRAWER_WIDTH = 80;

export const Layout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem(LocalStorageKeys.B2B_SIDEBAR_COLLAPSED);
    return saved === "true";
  });

  useEffect(() => {
    localStorage.setItem(LocalStorageKeys.B2B_SIDEBAR_COLLAPSED, isCollapsed);
  }, [isCollapsed]);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const currentDrawerWidth = isCollapsed
    ? COLLAPSED_DRAWER_WIDTH
    : FULL_DRAWER_WIDTH;

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        bgcolor: "background.default",
      }}
    >
      <Sidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        isCollapsed={isCollapsed}
        setIsCollapsed={setIsCollapsed}
      />
      <TopBar
        onMenuClick={handleDrawerToggle}
        drawerWidth={currentDrawerWidth}
      />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: { xs: 2, md: 4 },
          pt: { xs: 10, md: 12 },
          width: { xs: "100%", md: `calc(100% - ${currentDrawerWidth}px)` },
          transition: (theme) =>
            theme.transitions.create(["width", "margin"], {
              easing: theme.transitions.easing.sharp,
              duration: theme.transitions.duration.leavingScreen,
            }),
          position: "relative",
          zIndex: 1,
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
};
